<script>
    import {url} from '@sveltech/routify';
    import {fade} from 'svelte/transition';
    import {createEventDispatcher} from 'svelte';
    import storeTiposDeJornada from '../../Stores/tipos-de-jornada-store';
    import Caja from "../UI/Caja.svelte";
    import Boton from "../UI/Boton.svelte";
    import Subtitulo from "../UI/Subtitulo.svelte";
    import IconoDeTipo from "../TiposDeJornada/Icono.svelte";
    import Loading from "../UI/Loading.svelte";
    import Icono from "../UI/Icono.svelte";

    let listado, tipos;

    export let habilitado = false;
    export let guardando;

    const dispatcher = createEventDispatcher();

    $: tipos = $storeTiposDeJornada.listado.filter(x => x.activo);

    const eligeDeTipo = tipo => dispatcher('elige-de-tipo', tipo);
    const aplicarTipo = tipo => dispatcher('aplicar-tipo', tipo);
</script>

<style>
    .tipos {
        position: relative;
    }

    .guardando {
        background: rgba(255, 255, 255, .8);
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .tipo {
        margin: .5em 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .tipo-nombre {
        border: 0;
        font-family: inherit;
        font-size: inherit;
        display: flex;
        align-items: center;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Tipos de jornada</Subtitulo>
    </div>

    <div slot="botones">
        <Boton icono="edit" href={$url('/tipos-de-jornada')}>Editar&nbsp;tipos</Boton>
    </div>

    {#if tipos.length}
        <div class="tipos">
            <ul>
                {#each tipos as tipo}
                    <li class="tipo">
                        <button class="tipo-nombre" on:click={() => eligeDeTipo(tipo.nombre)}>
                            <IconoDeTipo tamano="pequeno" {tipo}/>

                            {tipo.nombre}
                        </button>

                        <Boton tamano="pequeno" on:click={() => aplicarTipo(tipo)}
                               disabled={!habilitado}
                                       tipo="neutral">
                            <Icono tamano={17} margen>check</Icono>
                            Aplicar
                        </Boton>
                    </li>
                {/each}
            </ul>
            {#if guardando}
                <div class="guardando" transition:fade>
                    <Loading/>
                </div>
            {/if}
        </div>
    {:else}
        <Loading/>
    {/if}
</Caja>